import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlErrorTable extends Layout {
    sourceMcErrorSchedule: DataSource;
    tableErrorSchedule: Table;
}
